<template>
  <div class="bg-base-100 rounded-lg p-6">
    <div
      class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-8"
    >
      <h2 class="text-xl font-semibold">Adresų sąrašas</h2>
      <div class="flex gap-2">
        <label class="input input-neutral input-sm">
          <DefaultIcon name="magnifying" size="w-3 h-3" />
          <input
            type="search"
            class="grow"
            placeholder="Paieška"
            :value="route.query.search || ''"
            @input="handleSearch"
          />
        </label>
        <router-link
          to="/addresses/new"
          class="btn btn-sm btn-success"
          title="Įtraukti naują adresą"
        >
          <DefaultIcon name="plus" size="w-4 h-4" />
          Naują
        </router-link>
      </div>
    </div>

    <div v-if="addressStore.isLoading" class="text-center py-4">
      <span class="loading loading-spinner loading-lg"></span>
    </div>

    <div v-else class="overflow-x-auto">
      <div v-if="addressStore.addresses.length > 0">
        <table class="table w-full mb-3">
          <thead>
            <tr>
              <th>Pavadinimas</th>
              <th>Adresas</th>
              <th>Koordinatės</th>
              <th>Sukūrė</th>
              <th>Veiksmai</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="address in addressStore.addresses" :key="address.id">
              <td>{{ address.title }}</td>
              <td>{{ address.address }}</td>
              <td>{{ address.lat }}, {{ address.lng }}</td>
              <td>{{ address.created_by }}</td>
              <td>
                <div class="flex gap-2">
                  <router-link
                    :to="'/addresses/' + address.id + '/edit'"
                    class="btn btn-sm btn-ghost btn-circle"
                    title="Redaguoti įrašą"
                  >
                    <DefaultIcon name="editPencil" size="w-4 h-4" />
                  </router-link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <Pagination :meta="addressStore.meta" />
      </div>
      <div v-else>
        <div v-if="route.query.search">
          Pagal pasirinktus parametrus adresų nerasta.
        </div>
        <div v-else>
          Adresų dar nesukūrėte. Įtraukite naują adresą paspausdami -
          Naują.
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useAddressStore } from "@/stores/addresses";
import { watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import DefaultIcon from "@/components/icons/DefaultIcon.vue";
import Pagination from "@/components/ui/pagination/PaginationComponent.vue";

const route = useRoute();
const router = useRouter();
const addressStore = useAddressStore();

let searchTimeout = null;

const loadAddresses = async () => {
  try {
    const { page = 1, ...params } = route.query;
    await addressStore.fetchAddresses(page, params);

    // Page no longer exists (e.g. last row on the last page was deleted)
    const lastPage = addressStore.meta?.last_page;
    if (lastPage > 0 && Number(page) > lastPage) {
      router.replace({ query: { ...route.query, page: lastPage } });
    }
  } catch (error) {
    console.error("Failed to fetch addresses:", error);
  }
};

watch(() => route.query, loadAddresses, { immediate: true });

const handleSearch = (event) => {
  if (searchTimeout) clearTimeout(searchTimeout);

  searchTimeout = setTimeout(() => {
    const value = event.target.value.trim();
    const query = { ...route.query };

    if (value.length >= 3) {
      query.search = value;
      delete query.page;
    } else {
      delete query.search;
      delete query.page;
    }

    router.push({ query });
  }, 300);
};
</script>
